import script from "./TokenWeightPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenWeightPill.vue?vue&type=script&setup=true&lang=ts"

import "./TokenWeightPill.vue?vue&type=style&index=0&id=659daadc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-659daadc"]])

export default __exports__